import axios from "axios";

export const getCollaboratorFolders = ({
  organization,
  id,
  space,
  filterCollaborator,
  roleCollaborator,
  year,
  synchro,
  loggedAs,
  filterCRMTypes,
  filterCRMGroupes,
  filterJuridicalForm,
  searchedValue,
  clientIds
}) => {
  const requestUrl = `/data/collaborator/folders`;
  let params = {
    organization: organization,
    id: id,
    space: space,
    filterCollaborator:
      synchro && loggedAs === "MANAGER" ? filterCollaborator : [],
    roleCollaborator: roleCollaborator,
    synchro: synchro,
    year: year,
    loggedAs: loggedAs,
    filterCRMTypes: filterCRMTypes,
    filterCRMGroupes: filterCRMGroupes,
    filterJuridicalForm: filterJuridicalForm,
    searchedValue: searchedValue,
    clientIds: clientIds
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorPresentations = ({
  organization,
  id,
  word,
  year,
  synchro = false
}) => {
  const requestUrl = `/data/collaborator/presentations`;
  let params = {
    organization: organization,
    id: id,
    word: word,
    year: year,
    synchro: synchro
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorAllPresentations = ({ organization, id }) => {
  const requestUrl = `/data/collaborator/all-presentations`;
  let params = {
    organization: organization,
    id: id
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorByIdOrApiId = ({ organization, id, apiId }) => {
  const requestUrl = `/data/collaborator`;
  let params = {
    organization: organization,
    apiId: apiId,
    id: id
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorPerformances = ({ organization, id, year }) => {
  const requestUrl = `/data/collaborator/performances`;

  let params = {
    organization: organization,
    year: year,
    id: id
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getCollaborators = data => {
  let {
    uen,
    searchWord,
    pageSize,
    paginationPage,
    noLimit,
    roles,
    year,
    synchro
  } = data;
  const requestUrl = `/data/collaborators`;
  let filter = [];

  if (searchWord && searchWord.length) {
    filter = [
      {
        property: "name",
        value: searchWord,
        operator: "like"
      }
    ];
  }
  let params = {
    limit: pageSize || 10,
    noLimit: noLimit,
    start: !paginationPage ? 0 : (paginationPage - 1) * pageSize,
    organization: uen,
    roles: roles,
    year: year,
    synchro: synchro,
    filter: JSON.stringify(filter)
  };
  return axios.get(requestUrl, {
    params
  });
};

export const saveIcsFile = ({ icsFile }) => {
  const requestUrl = `/data/saveIcsFile`;

  let formData = new FormData();
  formData.append("icsFile", icsFile);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/collaborator.js